import React, { useState } from "react";
import Button from "../../components/UI/Button";
import Card from "../../components/UI/Card";
import InfoModal from "../../components/UI/InfoDialog";

const DocumentGenerator = () => {
  const [selectedType, setSelectedType] = useState("internship");
  const [selectedTheme, setSelectedTheme] = useState("classic");
  const [modal, setModal] = useState({ isOpen: false });
  
  const documentTypes = [
    { value: "internship", label: "Internship Letter" },
    { value: "offer", label: "Offer Letter" },
    { value: "appreciation", label: "Appreciation Letter" },
  ];

  const themes = [
    { value: "classic", label: "Classic" },
    { value: "modern", label: "Modern" },
    { value: "creative", label: "Creative" },
  ];

  const generateDocument = () => {
    // alert(`Generating a ${selectedType} with ${selectedTheme} theme`);
    setModal({ isOpen: true});
  };

  return (
    <div className="font-poppins flex items-center justify-center p-6">
      <Card className="w-full max-w-lg">
        <h2 className="text-2xl dark:text-white font-semibold text-gray-800 mb-6 text-center">
          Document Generator
        </h2>

        <div className="mb-4">
          <label
            htmlFor="document-type"
            className="block text-sm dark:text-white font-medium text-gray-600 mb-2"
          >
            Select Document Type:
          </label>
          <select
            id="document-type"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            className="block dark:bg-black dark:text-white dark:border-gray-700 w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500"
          >
            {documentTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label
            htmlFor="theme"
            className="block text-sm dark:text-white font-medium text-gray-600 mb-2"
          >
            Select Theme:
          </label>
          <select
            id="theme"
            value={selectedTheme}
            onChange={(e) => setSelectedTheme(e.target.value)}
            className="block dark:bg-black dark:text-white dark:border-gray-700 w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500"
          >
            {themes.map((theme) => (
              <option key={theme.value} value={theme.value}>
                {theme.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-center">
          <Button onClick={generateDocument} className="bg-blue-600 hover:bg-blue-700 ">
            Generate Document
          </Button>
        </div>
      </Card>
      <InfoModal
        isOpen={modal.isOpen}
        onClose={() => setModal({ isOpen: false })}
        message={`Generating a ${selectedType} with ${selectedTheme} theme`}
      />
    </div>
  );
};

export default DocumentGenerator;
